var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-alert"},[_c('transition-group',{attrs:{"name":"alert-fade"}},_vm._l((_vm.messages),function(item,index){return _c('div',{key:index,staticClass:"alert border-0 text-center",class:("alert-" + (item.status))},[_vm._v(_vm._s(item.message))])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56cd98e8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alert.vue
// module id = null
// module chunks = 